import { chunk } from './chunk';

const unscheduledPlanDate = '0000-00-00';
const suggestedColumn = 'user_submitted';

const firstRow = document.documentElement.clientWidth < 2048 ? 1 : 2;

const unscheduledTilesPerRow = () => {
  if (document.documentElement.clientWidth <= 800) {
    return 1;
  } else if (document.documentElement.clientWidth < 2048) {
    return 2;
  }
  return 3;
};

const tilesChunks = (column, collection, perRow) => {
  if (column.includes(unscheduledPlanDate)) {
    // Need this to slice the columns to fit in plan tab left section layout, with new tile component
    const firstChunk = chunk(collection.slice(0, firstRow), firstRow);
    const chunks = chunk(collection.slice(firstRow), unscheduledTilesPerRow());

    return firstChunk.concat(chunks);
  }

  if (column.includes(suggestedColumn)) {
    return chunk(collection, unscheduledTilesPerRow());
  }

  return chunk(collection, perRow);
};

export { tilesChunks };
